import { FormComponentWrapper } from 'components/FormComponentWrapper';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { InternalFormStepper } from './InternalFormStepper';
import type { FormStepperProps } from './types';

export const FormStepper = <T extends FieldValues>({
  name,
  control,
  description,
  label,
  wrapperClassname,
  message,
  disabled,
  ...stepperProps
}: FormStepperProps<T>) => {
  return (
    <Controller
      name={name}
      {...(control
        ? { control }
        : {
            // if undefined, Controller reads from FormProvider
          })}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <FormComponentWrapper
          name={name}
          description={description}
          label={label}
          error={error}
          className={wrapperClassname}
          message={message}
          disabled={disabled}
        >
          <InternalFormStepper
            {...stepperProps}
            // This will guarantee that the stepper values is correct when updated
            // It was not updating the value when it changed for the first time
            onChange={(value) => {
              onChange(value);
              onBlur();
            }}
            value={value}
          />
        </FormComponentWrapper>
      )}
    />
  );
};
